import { useMemo } from 'react';
import { LuxuryTaxSupportCompact } from '../../../../S/pricing/components/luxury-tax-support-compact/luxury-tax-support-compact.component';
import { ExpertSessionCompact } from '../../../../S/pricing/components/expert-session-compact/expert-session-compact.component';
import {
  EXPERT_SESSION_FEATURES,
  EXPERT_SESSION_HEADING,
  LUXURY_TAX_FEATURES,
  LUXURY_TAX_HEADING,
  LUXURY_TAX_UTM_REF,
} from './constants';
import { IPartnerPlanData } from '../../../types';
import { transformCompactCardsData } from './compact-cards.utils';

interface CompactCardsProps {
  luxuryPlanData: IPartnerPlanData[];
  expertSessionData: IPartnerPlanData[];
  luxuryHeading?: string;
  luxuryDescription?: string[];
  utmRefBuyNow?: string;
  utmRefKnowMore?: string;
}

export const CompactCards: React.FC<CompactCardsProps> = ({
  luxuryPlanData,
  expertSessionData,
  luxuryHeading,
  luxuryDescription,
  utmRefBuyNow,
  utmRefKnowMore,
}) => {
  const compactCardsData = useMemo(
    () => transformCompactCardsData(luxuryPlanData, expertSessionData),
    [luxuryPlanData, expertSessionData]
  );

  if (!compactCardsData) {
    return null;
  }

  return (
    <div className="flex gap-4 sm:flex-col">
      <LuxuryTaxSupportCompact
        utm_ref={LUXURY_TAX_UTM_REF}
        utm_ref_buy_now={utmRefBuyNow}
        utm_ref_know_more={utmRefKnowMore}
        heading_1={luxuryHeading ?? LUXURY_TAX_HEADING}
        description={luxuryDescription ?? LUXURY_TAX_FEATURES}
        price={compactCardsData.luxury.price}
        original_price={compactCardsData.luxury.originalPrice}
        discount={compactCardsData.luxury.discount}
        coupon_code={compactCardsData.luxury.couponCode}
        coupon_discount={compactCardsData.luxury.couponDiscount}
        listingId={compactCardsData.luxury.listingId}
        planId={compactCardsData.luxury.planId}
      />
      <ExpertSessionCompact
        utm_ref={LUXURY_TAX_UTM_REF}
        utm_ref_buy_now={utmRefBuyNow}
        utm_ref_know_more={utmRefKnowMore}
        heading_1={EXPERT_SESSION_HEADING}
        description={EXPERT_SESSION_FEATURES}
        price={compactCardsData.expert.price}
        original_price={compactCardsData.expert.originalPrice}
        discount={compactCardsData.expert.discount}
        coupon_code={compactCardsData.expert.couponCode}
        coupon_discount={compactCardsData.expert.couponDiscount}
        listingId={compactCardsData.expert.listingId}
        planId={compactCardsData.expert.planId}
      />
    </div>
  );
};
